import axios from "axios";
import { GET_VERIFICATION_SERVICES, get_request_config} from "@/utils/system_constants/constant"
import alert_mixin from '@/utils/mixins/alert_mixin';

export default {
  name: "VerificationServices",
  mixins: [alert_mixin],

  data: () => ({
    services: [],
  }),

  mounted() {
    this.fetch_verification_services();
  },

  methods: {
    fetch_verification_services() {
      axios
        .get(GET_VERIFICATION_SERVICES, get_request_config())
        .then((res) => {
          if (res.data.status === "success" && res.data.data) {
            this.services = res.data.data.map((service) => ({
              id: service.id,
              icon: this.resolve_icon(service.name),
              title: service.name,
              price: service.price != null ? `R ${Number(service.price).toFixed(2)}` : "R 0.00",
              description: service.description,
            }));
          } else {
            this.show_error(res.data.message || "Failed to load services");
          }
        })
        .catch(() => {
          this.show_error("Failed to load verification services");
        });
    },

    resolve_icon(name) {
      const map = {
        "kyc verification": "bi-person-check",
        "cipc verification": "bi-building",
        "aml verification": "bi-shield-check",
        "id verification": "bi-person-badge",
        "credit report verification": "bi-credit-card",
      };
      const key = name.toLowerCase();
      return Reflect.has(map, key) ? Reflect.get(map, key) : "bi-patch-check";
    },

    redirect_to_configure_services(service) {
      const verification_form_id = this.$route?.query?.verification_form_id
        ? String(this.$route.query.verification_form_id)
        : undefined;

      if (!service?.id) {
        this.$router.push({ path: '/configure_verification_services' });
        return;
      }

      const query = { serviceId: String(service.id) };
      if (verification_form_id) query.verification_form_id = verification_form_id;

      this.$router.push({
        path: '/configure_verification_services',
        query,
      });
    }
  },
};
